import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import ViewBooking from './ViewBooking';
import InvestorServices from '../../services/InvestmentService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faEdit   } from '@fortawesome/free-solid-svg-icons';
import UpdateInvestmentProperty from '../Update Model/UpdateInvestmentProperty';

function ViewUser({ user, closeModal }) {

  const [property, setProperty] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [temp, setTemp] = useState(0);
  // console.log(property);
  useEffect(() => {
    if (!user) return;
    const fetchInvestment = async () => {
      try {
        const response = await InvestorServices.getInvestment(user._id);
        setProperty(response.data);
        // console.log(response.data)
      } catch (error) {
        console.error('Error fetching property:', error);
      }
    };
    fetchInvestment();
  }, [user,temp]);
  const handleEditDetails = (investment) => {
    setSelectedEdit(investment);
    setIsEditModalOpen(true);

  };
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { date: formattedDate, time: formattedTime };
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return 'N/A';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
  };





  if (!user) return null;

  return (
    <div className="modal fade viewbox edit-box show d-block" tabIndex={-1} aria-labelledby="userModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Investor Profile</h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="container">
              {/* User Info Section */}

              <div className="container-box user-manager" style={{ padding: '10px', marginTop: '15px' }}>
                <h4>Investor Information</h4>
                <ul className="user-details list-unstyled d-flex justify-content-between">
                  <li>
                    <span>Investor ID</span>
                    <p>{user?.investorId || 'N/A'}</p>
                  </li>
                  <li>
                    <span>Name</span>
                    <p>{user?.name || 'N/A'}</p>
                  </li>
                  <li>
                    <span>Email</span>
                    <p>{user?.email || 'N/A'}</p>
                  </li>
                </ul>
                <ul className="user-details list-unstyled d-flex justify-content-between">
                  <li>
                    <span>Phone</span>
                    <p>{user?.mobileNo || 'N/A'}</p>
                  </li>
                  <li>
                    <span>Date Joined</span>
                    <p>{formatDate(user?.createdAt) || 'N/A'}</p>
                  </li>
                  <li>
                    <span>Status</span>
                    <p>{user?.status || 'N/A'}</p>
                  </li>
                </ul>
              </div>
              <div className="container-box user-manager" style={{ padding: '10px', marginTop: '15px' }}>
                <h4>Banking Details</h4>
                <ul className="user-details list-unstyled d-flex justify-content-between">
                  <li>
                    <span>Account Holder Name</span>
                    <p>{user?.accountHolderName || 'N/A'}</p>
                  </li>
                  <li>
                    <span>Bank Account Number</span>
                    <p>{user?.accountNo || 'N/A'}</p>
                  </li>
                  <li>
                    <span>Bank Name</span>
                    <p>{user?.bankName || 'N/A'}</p>
                  </li>
                </ul>
                <ul className="user-details list-unstyled d-flex justify-content-start">
                  <li className='text-start'>
                    <span>IFSC Number</span>
                    <p>{user?.ifscCode || 'N/A'}</p>
                  </li>
                </ul>
              </div>

              {/* Booking History Section */}
              <div className="booking-detail container-box user-manager" style={{ marginTop: '20px' }}>
                <h4>Investment History</h4>
                <table className="table table-striped" style={{ border: '1px solid #FFFFFF', borderRadius: '10px' }}>
                  <thead style={{ backgroundColor: '#D9D9D9' }}>
                    <tr>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Property<br /> ID</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Property<br />  Name</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Room<br /> Number</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Location</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Purchase<br /> Date</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Price</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Status</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>

                    {property && property.length > 0 ? (
                      property.map((investment, index) => (
                        <tr key={index} style={{ backgroundColor: '#F9FAFF' }}>
                          <td className='bookingId'>#{investment?.propertyId || 'N/A'}</td>
                          <td>{investment?.property?.name || 'N/A'}</td>
                          <td>{investment?.room?.roomNumber || 'N/A'}</td>
                          <td>{investment?.property?.location || 'N/A'}</td>
                          <td>{formatDate(investment?.purchaseDate) || 'N/A'}</td>
                          <td>{investment?.investmentPrice || 'N/A'}</td>
                          <td>{investment?.propertyStatus || 'N/A'}</td>
                          <td>
                            <button className="view-details-btn edit-btn" onClick={() => handleEditDetails(investment)}><FontAwesomeIcon icon={faEdit} /></button>
                          </td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: 'center' }}>
                          No Investment History Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <Modal
              isOpen={isEditModalOpen}
              onRequestClose={closeEditModal}
              contentLabel="User Details"
              className="modal-content"
              overlayClassName="modal-overlay"
            >
              <UpdateInvestmentProperty investment={selectedEdit} closeModal={closeEditModal} onSuccess={()=> setTemp(temp+1)}   />
            </Modal>
          </div>
          <div className="modal-footer d-flex">
            <button type="button" className="site-btn-green" style={{ marginBlock: '15px' }} onClick={closeModal}>
              CLOSE
            </button>
          </div>
        </div>
      </div>

    </div>
  );
}

export default ViewUser;

